/* global globalThis */
const openings = new WeakMap();
const context = vm => JSON.stringify([vm.$route.fullPath, vm.$route.params.id, vm.$route.params.idAgenda]);
const uncertain = (continuar = false) => Object.assign(new Error("Não foi possível confirmar a abertura. Use Conferir atendimento para consultar novamente e retomar as etapas pendentes, sem repetir a criação."), { estado: "INDETERMINADO", podeContinuar: continuar });

export async function requisitarAbertura(api, jwt, recurso, parametros) {
  if(!jwt.getToken()) { throw Object.assign(new Error("Sessão indisponível. Entre novamente para continuar."), { enviado: false }); }
  const { signal, ...body } = parametros;
  api.setHeader();
  const { data } = await api.postOnce(`atendimentos/access/${recurso}`, body, { signal, timeout: 120000 });
  if(recurso === "obterAtendimentosHoje") {
    // O LEFT JOIN legado também pode retornar uma linha sem detalhe.
    if(!Array.isArray(data) || data.some(row => !row || !Array.isArray(row.DADOS))) { throw new Error("Resposta inválida dos dados do atendimento."); }
    if(body.ID_ATENDIMENTO && data.some(row => String(row.ID_ATENDIMENTO) !== String(body.ID_ATENDIMENTO) ||
      String(row.ID_PACIENTE) !== String(body.ID_PACIENTE))) { throw new Error("As fichas retornadas pertencem a outro atendimento."); }
    return data;
  }
  if(body.CONFIRMAR_ABERTURA) {
    const same = (a, b) => String(a || "0") === String(b || "0");
    if(data?.contrato !== "ABERTURA_ATENDIMENTO_V1" || data.ID_CLIENT_REQUEST !== body.ID_CLIENT_REQUEST ||
      !same(data.ID_PACIENTE, body.ID_PACIENTE) || !same(data.ID_AGENDA, body.ID_AGENDA)) { throw uncertain(); }
    if(data.resultado !== true || data.estado !== "CONFIRMADO") { throw uncertain(data.PODE_CONTINUAR === true); }
    const row = data.ATENDIMENTO;
    if(!row || !/^[1-9]\d*$/.test(String(row.ID_ATENDIMENTO)) || !/^[1-9]\d*$/.test(String(row.ID_MEDICO)) ||
      !same(row.ID_PACIENTE, body.ID_PACIENTE) || !same(row.ID_AGENDA, body.ID_AGENDA) ||
      (body.ID_ATENDIMENTO && !same(row.ID_ATENDIMENTO, body.ID_ATENDIMENTO))) { throw uncertain(); }
    if(data.AGENDA && (!same(data.AGENDA.ID_AGENDA, body.ID_AGENDA) || !same(data.AGENDA.ID_PACIENTE, body.ID_PACIENTE))) { throw uncertain(); }
    return { ...row, AGENDA_ABERTURA: data.AGENDA };
  }
  const atendimento = recurso === "consultarInicioAtendimento" ? data?.ATENDIMENTO : data;
  if(!atendimento || typeof atendimento !== "object" || Array.isArray(atendimento)) { throw uncertain(); }
  if(!atendimento.ID_ATENDIMENTO) { throw uncertain(); }
  return atendimento;
}

export function aberturaAtendimento(vm) {
  if(!openings.has(vm)) { openings.set(vm, criarAberturaAtendimento(vm)); }
  return openings.get(vm);
}

export function criarAberturaAtendimento(vm) {
  let state = null, closed = false;
  const valid = request => !closed && state === request && request.context === context(vm);
  return {
    abrir(parametros) {
      if(closed) { return Promise.resolve(null); }
      if(!state || state.context !== context(vm)) {
        state = { context: context(vm), parametros: { ...parametros, CONFIRMAR_ABERTURA: true,
          ID_CLIENT_REQUEST: Array.from(globalThis.crypto.getRandomValues(new Uint32Array(4)), n => n.toString(16).padStart(8, "0")).join("") }, enviado: false, atendimento: null, promise: null };
      }
      const request = state;
      if(request.promise) { return request.promise; }
      request.promise = Promise.resolve().then(async () => {
        if(!valid(request)) { return null; }
        if(request.atendimento) { return request.atendimento; }
        if(!request.restaurada) {
          const saved = await vm.buscarAberturaPendente?.(request.parametros);
          if(!valid(request)) { return null; }
          if(saved?.parametros) { request.parametros = saved.parametros; request.enviado = true; }
          request.restaurada = true;
        }
        await vm.guardarOperacaoProntuario?.("abertura", { parametros: request.parametros });
        if(!valid(request)) { return null; }
        let atendimento;
        if(!request.enviado) {
          request.enviado = true;
          try {
            atendimento = await vm.iniciarAtendimentoConfirmado(request.parametros);
          } catch(error) {
            if(error.enviado === false) { request.enviado = false; throw error; }
            // Resultado desconhecido: somente a consulta abaixo pode recuperar a abertura.
          }
        }
        if(!valid(request)) { return null; }
        if(!atendimento?.ID_ATENDIMENTO) {
          try { atendimento = await vm.consultarInicioAtendimento(request.parametros); }
          catch(error) {
            if(!valid(request)) { return null; }
            // O diário do servidor autoriza apenas etapas que nunca chegaram a ser enviadas.
            if(!error.podeContinuar) { throw uncertain(); }
            try { atendimento = await vm.iniciarAtendimentoConfirmado(request.parametros); }
            catch(resumeError) { throw uncertain(); }
          }
        }
        if(!valid(request)) { return null; }
        if(!atendimento?.ID_ATENDIMENTO) { throw uncertain(); }
        request.atendimento = atendimento;
        await vm.terminarOperacaoProntuario?.(request.parametros.ID_CLIENT_REQUEST);
        return atendimento;
      }).finally(() => { request.promise = null; });
      return request.promise;
    },
    cancelar() {
      // Uma abertura confirmada pode ser encerrada; uma incerta continua restrita a consultas.
      if(state?.atendimento) { state = null; }
    },
    encerrar() { closed = true; }
  };
}
